import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import trmty_logo from '../../assets/images/TRIMURTI-LOGO.png';
import processing from '../../assets/images/Group.png';
import processBatch from '../../assets/images/Vector.png'
import asignTask from '../../assets/images/assignTasks.png'
import collapseIcon from '../../assets/images/collapse-arrow.svg';
import material from '../../assets/images/materials.svg';
import styles from './Sidebar.module.css';

interface SidebarProps {
  isOpen: boolean; 
  onClose: () => void; 
  isCollapsed: boolean; 
  onCollapseToggle: () => void; 
}

const Sidebar: React.FC<SidebarProps> = ({ isOpen, onClose, isCollapsed, onCollapseToggle }) => {
  let selectedRole = undefined;
  try {
    selectedRole = require('../../store/authStore').useAuthStore().selectedRole;
  } catch { }

  const navigation = [
    ...(selectedRole === 'Admin'   ? [
    { 
      name: 'Processing & Packaging', 
      href: '/admin/processing',
      activeFor: ['/admin/processing', '/admin/create-batch', '/admin/batch-details', '/admin/edit-batch', '/supervisor/processing', '/supervisor/analytics', '/supervisor/batches'],
      icon: <img src={processing} alt="Processing Batches" />
    },
    ]:[]),
        ...( selectedRole === 'LineSupervisor'  ? [
    { 
      name: 'Processing Batches', 
      href: '/supervisor/analytics',
      activeFor: [ '/supervisor/processing', '/supervisor/analytics', '/supervisor/batches'],
      icon: <img src={processBatch} alt="Processing Batches" />
    },
    ]:[]),
    ...(selectedRole === 'Admin' ? [
      { 
        name: 'Materials', 
        href: '/admin/materials',
        activeFor: ['/admin/materials'],
        icon: <img src={material} alt="Material" />
      }
    ] : []),
    ...(selectedRole === 'MachineOperator' || selectedRole === 'CleaningWorker' || selectedRole === 'NichromeOperators' || selectedRole === 'PackagingWorker' ? [
    {
      name:'Assigned Tasks', 
      href: 'worker/tasks',
      activeFor: ['/worker/tasks', '/worker/packaging-task', '/worker/chemical-treatment', '/worker/task-details', '/worker/cleaning-details'],
      icon: <img src={asignTask} alt="Processing Batches" />
    }
    ] : []),
  ];

  const location = useLocation();

  const isActive = (item:any) => {
    return item.activeFor.some((path:any) => location.pathname.startsWith(path));
  };

  return (
    <>
      {isOpen && <div className={styles.overlay} onClick={onClose} />}
      <div
        className={`
          ${styles.sidebarContainer} 
          ${isOpen ? styles.open : ''}
          ${isCollapsed ? styles.collapsed : ''}
        `}
      >
        <div className={styles.sidebarInner}>
          <div className={styles.sidebarHeader}>
            <img src={trmty_logo} alt="Trimurti Logo"  className={`${styles.logo} ${isCollapsed ? styles.logoOpen : styles.logoClosed}`} />
          </div>
          <nav className={styles.nav}>
            <ul>
              {navigation.map((item) => (
                <li key={item.name}>
                  <NavLink
                    to={item.href}
                    className={`${styles.navLink} ${isActive(item) ? styles.active : ''}`}
                    onClick={onClose}
                    title={item.name}
                  >
                    <span className={styles.navIcon}>{item.icon}</span>
                    <span className={styles.navText}>{item.name}</span>
                  </NavLink>
                </li>
              ))}
            </ul>
          </nav>
          <div className={styles.collapseButtonWrapper}>
            <button onClick={onCollapseToggle} className={styles.collapseButton}>
              <img style={{height: '56px'}}  alt="Collapse sidebar" src={collapseIcon} className={isCollapsed ? styles.arrowRotated : ''} />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;